import { Environment, ExtendedWindow } from '@/commons/types'
export const ENVIRONMENT: Environment = (window as unknown as ExtendedWindow).CONFIG
